module.exports = __webpack_public_path__ + "static/media/5.be10ce6a.jpg";